import { z } from 'zod';
export const VALUE_TYPES = ['string', 'text', 'integer', 'boolean', 'enum', 'json'];
export const settingCreateSchema = z.object({
    setting_key: z
        .string()
        .min(1, 'Setting key is required')
        .regex(/^[a-z][a-z0-9]*(\.[a-z][a-z0-9_]*)*$/, 'Must be dot-notation (e.g., ai.model)'),
    setting_value: z.any().optional(),
    default_value: z.any().optional(),
    value_type: z.enum(VALUE_TYPES).default('string'),
    allowed_values: z.any().optional(),
    category: z.string().min(1, 'Category is required').default('general'),
    name: z.string().min(1, 'Name is required'),
    description: z.string().optional(),
    seq_num: z.coerce.number().int().min(0).default(0),
    is_system: z.boolean().default(false),
    is_sensitive: z.boolean().default(false),
    is_deletable: z.boolean().default(true),
    is_hidden_from_tenant: z.boolean().default(false),
    requires_restart: z.boolean().default(false),
});
export const settingUpdateSchema = settingCreateSchema.partial();
//# sourceMappingURL=settingSchema.js.map